export default "__VITE_ASSET__CEo2i0zE__"